import { render, staticRenderFns } from "./InvestigationDashboard.vue?vue&type=template&id=69f1d3a5&scoped=true&"
import script from "./InvestigationDashboard.vue?vue&type=script&lang=js&"
export * from "./InvestigationDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InvestigationDashboard.vue?vue&type=style&index=0&id=69f1d3a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f1d3a5",
  null
  
)

export default component.exports